
import Vue from 'vue'
const validate = (value, { startDate, isSameOrAfter = false }) => {
  if (!startDate) return true
  if (!value) return false
  // дата value должна быть больше или равна даты начала startDate
  return isSameOrAfter
    ? Vue.prototype.$moment(value).isSameOrAfter(startDate)
    : Vue.prototype.$moment(value).isAfter(startDate)
}

export default {
  validate,
  params: ['startDate', 'isSameOrAfter']
}
